import OverlaySpinner from '../../overlay/presentational/OverlaySpinner'
import OverlayText from '../../overlay/presentational/OverlayText'
import WrapperPageSimple from './WrapperPageSimple'

const WrapperPageSpinner = ({
    pageTitle='',
    pageTitleTransId='',
    addClassName='',
    closePagePath = false,
    handleScroll = false,
    id= false,

    children,

    pending=false,
    error=false,
    success=false,

    pendingTextTransId,
    errorTextTransId,
    successTextTransId,

    errorMsg='',
    successMsg='',

    onClickSuccesButton,
    onClickErrorButton
}) => {
    let overlay = ''

    if(pending) {
        overlay = <OverlaySpinner
            transId={pendingTextTransId}
        />
    } else if(error)  {
        overlay =  <OverlayText
            titleTransId={errorTextTransId}
            text={errorMsg}
            buttonTextTransId='button_close'
            onClickButton={onClickErrorButton}
        />
    } else if(success) {
        overlay =  <OverlayText
            titleTransId={successTextTransId}
            text={successMsg}
            buttonTextTransId='button_close'
            onClickButton={onClickSuccesButton}
        />
    }

    return <WrapperPageSimple
        pageTitle={pageTitle}
        pageTitleTransId={pageTitleTransId}
        children={children}
        overlay={overlay}
        addClassName={addClassName}
        closePagePath={closePagePath}
        handleScroll={handleScroll}
        id={id}
    />
}

export default WrapperPageSpinner

